import React, { Component } from "react";
import FormViewer from "../components/FormViewer";
import LoaderButton from "../components/LoaderButton";
import HttpServices from "../utils/Http.services";
import { checkPermission, checkTranslation, translate } from "../utils/useful";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import ButtonAnimated from "../components/buttons/ButtonAnimated";
import { getBoundingClientRect } from "../utils/functions";

class ItemModal extends Component {

    componentDidMount() {
        // console.log('itmmmmmda1l', this.props.permissions.stage[this.props.page.workflow], this.props)
        this.checkFieldPermission()

        this.setState({ data: this.props.initData ?? {}, init: true })

        // let stickyBar = this.stickyBar
        // stickyBar.style.height = 'initial';
        // stickyBar.style.height = (stickyBar.clientHeight) + "px";
        // let height = getBoundingClientRect(stickyBar).height
        // this.setState({ stickyBarHeight: height })
    }

    componentDidUpdate(prevProps) {
        if (this.props.initData != prevProps.initData) {
            // console.log('itmmmmmda2', this.props.initData)

            // let stickyBar = this.stickyBar
            // stickyBar.style.height = 'initial';
            // stickyBar.style.height = (stickyBar.clientHeight) + "px";
            // let height = getBoundingClientRect(stickyBar).height
            // this.setState({ stickyBarHeight: height })
            this.checkFieldPermission()
            if (!this.props.initData) {
                this.form.clearForm()
            }
            this.setState({ init: false, data: this.props.initData ?? {} }, () => {
                this.setState({ init: true })
            })
        }
        else if (this.props.headers != prevProps.headers) {
            this.checkFieldPermission()
        }


        // if (JSON.stringify(this.props.headers) != JSON.stringify(prevProps.headers)) {
        //     this.hideModal()
        // }
    }
    checkFieldPermission = () => {
        // console.log('itmmmmmda1l', this.props.permissions.stage[this.props.page.workflow][this.props.initData['**stage'].value.stage.id], this.props.initData)
        let permissions = this.props.permissions
        // console.log('permissionsrec', permissions)
        const headers = this.props.headers
        if (this.props.page && this.props.initData) {

            const stageId = this.props.initData['**stage']?.value?.stage?.id
            if (this.props.page.workflow && permissions?.stage[this.props.page.workflow] && permissions?.stage[this.props.page.workflow][this.props.page._id]
                && permissions?.stage[this.props.page.workflow][this.props.page._id][stageId] != '*' && (permissions?.stage[this.props.page.workflow][this.props.page._id][stageId]?.edit?.fields || permissions?.stage[this.props.page.workflow][this.props.page._id][stageId]?.view?.fields)) {
                const viewableFields = permissions?.stage[this.props.page.workflow][this.props.page._id][stageId]?.view?.fields
                const fields = permissions?.stage[this.props.page.workflow][this.props.page._id][stageId]?.edit?.fields
                headers.map((header) => {
                    let editCheck
                    let viewCheck

                    if ((fields && fields.includes(header.key)) || !fields) {
                        editCheck = true
                    }

                    if ((viewableFields && viewableFields.includes(header.key)) || !viewableFields) {
                        viewCheck = true
                    }

                    if (!editCheck || !viewCheck) {
                        if (!header.information) {
                            header.information = {}
                        }
                        header.information.disabled = true
                    }
                })

            }
        }

        this.setState({ headers: headers })
    }
    submitForm = () => {
        if (this.props.submitForm) {
            let data = this.form.getForm()

            // console.log('forrrrrrrrm',data)
            // return
            if (data) {
                this.setState({ isPostingData: true })
                this.props.submitForm(data, null, (data, err) => {

                    this.setState({ isPostingData: false })

                    if (err) {
                        return
                    }
                    this.props.setData('edit', false, 'CollectionView', () => {
                        this.form.clearForm()

                    })
                })
            }
        } else {
            this.postValue()
        }
    }

    formNextPage = () => {
        this.form.nextPage()
    }

    formBackPage = () => {
        this.form.backPage()
    }

    open = () => {
        this.props.setData('edit', true, 'CollectionView')
        this.setState({ showModal: true })
    }

    close = () => {
        this.hideModal()
    }

    showModal = () => {
        this.open()
    }

    hideModal = () => {
        this.props.setData('edit', false, 'CollectionView')
        this.onClose()
        if (this.form) {
            this.form.clearForm()
        }
        setTimeout(() => {
            this.setState({ showModal: false })
        }, 500);
    }

    state = {
        countries: [],
        actions: {
            cancel: { key: "cancel", label: "{{lang}}cancel", color: '#777', bgColor: '#e1e1e1', function: this.hideModal },
            submit: { key: "submit", label: "{{lang}}submit", bgColor: this.props.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', color: '#fff', function: this.submitForm, loader: "isPostingData" },
        },
        data: [],
        init: false,
        stickyBarHeight: 46.8,
        headers: []
    }

    onClose = () => {
        setTimeout(() => {
            this.setState({ showModal: false })
        }, 500);

        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    postValue = () => {


        if (this.form) {
            let data = this.form.getForm()
            this.setState({ errors: null })
            let page = this.props.page
            if (data) {
                let isEditing = data._id ? true : false
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                data.page = this.props.page?.key
                this.setState({ isPostingData: true })
                if (page.postBody) {
                    data = { ...data, ...page.postBody }
                }
                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {
                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }
                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    this.hideModal()
                    this.form.clearForm()

                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
                    if (!isEditing && this.props.itemAdded) {
                        this.props.itemAdded(fetchResult.info)
                    }
                    if (isEditing && this.props.itemEdited) {
                        if (fetchResult.info) {
                            this.props.itemEdited(fetchResult.info, data._id)
                        } else {
                            this.props.itemEdited(data, data._id)
                        }
                    }
                })
            }
        }
    }

    setFormStatus = (key, value) => {
        this.setState({ [key]: value })
    }

    scrollToTop = () => {
        this.container.scrollTo(0, 0)
    }

    backButton() {
        if (this.state.hasBack) {
            return (
                <div className=" mld-2"  >
                    <div className="" >
                        <LoaderButton
                            onClick={this.formBackPage}
                            // isLoading={this.state[prop.loader]}
                            text={checkTranslation('Back')}
                            // type={"Oval"}
                            className={"text-bold text-small text-center flexcc w-100 br-20 py-1  " + (this.state.canSubmit ? '' : 'gray-image')}
                            background={'#eee'}
                            width={20}
                            height={20}
                            color={'#777'}
                        />
                    </div>
                </div>
            )

        }
    }

    render() {
        return (
            <div className="w-100 h-100" style={{ display: this.props.edit ? 'flex' : 'none', position: 'absolute', top: '0px', zIndex: 4, }} width={this.props.width} ref={el => this.modal = el}>
                <div className="h-100 w-100" ref={el => this.container = el} style={{ backgroundColor: '#fff', }}>
                    <div ref={el => this.stickyBar = el} className="flexcb px-2 py-1 " style={{ zIndex: 2, borderBottom: '1px solid #eee', backgroundColor: '#f6f6f6' }}>
                        <div className="flexc w-80  py-2 px-3">
                            <div className="flexcc br-4 text-big color-white text-bold" style={{ height: 22, width: 22, background: this.props.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))' }}>
                                <p>+</p>
                            </div>
                            <p className="text-bold text-normal px-1">{(this.props.title ?? translate(this.props?.initData?._id ? "useful.Edit" : "New Record"))}</p>
                        </div>
                        <div className="flexce w-100 px-2 scroll-no-scrollbar">
                            {Object.values(this.state.actions).map((prop, index) => {
                                if (prop.key == 'submit' && this.state.hasNext) {
                                    return (
                                        <div key={index} className="flexc">
                                            {this.backButton()}
                                            <div className=" mld-2">
                                                <div className='flexc'>
                                                    <ButtonAnimated
                                                        iconwidth='24px'
                                                        onClick={this.formNextPage}
                                                        title={checkTranslation('Next')}
                                                        icon='/assets/icons/angle-right-white2.svg'
                                                        textColor={prop.color ?? '#000'}
                                                        // invert={!this.props.colors?.iconInvert}
                                                        bg={prop.bgColor}
                                                        isLoading={this.state[prop.loader]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div key={index} className="flexc">
                                            {prop.key == 'submit' && (
                                                this.backButton()
                                            )}
                                            <div className=" mld-2">
                                                <div className='flexc'>
                                                    {(checkPermission(this.props.permissions, `collection.${this.props.page?._id}.${this.props.edit ? 'edit' : 'create'}`) && prop.key == 'submit') ?
                                                        (<ButtonAnimated
                                                            iconwidth='24px'
                                                            onClick={prop.function}
                                                            title={checkTranslation(prop.label)}
                                                            icon='/assets/icons/angle-right-white2.svg'
                                                            textColor={prop.color ?? '#000'}
                                                            // invert={!this.props.colors?.iconInvert}
                                                            bg={prop.bgColor}
                                                            isLoading={this.state[prop.loader]}
                                                        />)
                                                        :
                                                        (<ButtonAnimated
                                                            iconwidth='24px'
                                                            onClick={prop.function}
                                                            title={checkTranslation(prop.label)}
                                                            // icon='/assets/icons/angle-right-white2.svg'
                                                            textColor={prop.color ?? '#000'}
                                                            // invert={!this.props.colors?.iconInvert}
                                                            bg={prop.bgColor}
                                                            isLoading={this.state[prop.loader]}
                                                        />)
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    </div>
                    <div className="w-100 flexc flex-column pt-2 pb-5 scroll-no-scrollbar" style={{ backgroundColor: 'rgb(245, 245, 245)', height: `calc(100% - ${this.state.stickyBarHeight}px)`, paddingLeft: '2%', paddingRight: '2%' }}>
                        <div className="w-100 mt-2 px-2 " style={{ paddingBottom: '10px', maxWidth: 800, }}>
                            {/* {console.log('this.2props.headersthis.props.headers', this.state.data)} */}
                            {this.state.init && (
                                <>

                                    <FormViewer ref={el => this.form = el} forceInputUpdate={this.props.forceInputUpdate} functionsHandler={this.props.functionsHandler} headers={this.state.headers} pages={this.props.pages} initData={this.state.data} data={this.state.data} sectionStyle={{ background: '#fff', boxShadow: '0px 0px 20px #00000005', borderRadius: 10, padding: '10px 0px', marginBottom: 30, }} width={this.props.width} errors={this.state.errors} formClass="bordered-form" inputClass={'bordered-input'} variables={this.props.variables} setFormStatus={this.setFormStatus} scrollToTop={this.scrollToTop} />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(ItemModal);